module.exports = __webpack_public_path__ + "img/img-3.46a7a4a0.webp";